module.exports = __webpack_public_path__ + "img/1491529416.b7aee9d0.jpg";